module.exports = __webpack_public_path__ + "img/invoiceFail.28dbef9d.png";